import { render, staticRenderFns } from "./editFixedPurchasesReturn.vue?vue&type=template&id=27132f32&scoped=true&"
import script from "./editFixedPurchasesReturn.vue?vue&type=script&lang=js&"
export * from "./editFixedPurchasesReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27132f32",
  null
  
)

export default component.exports